const latestGallery = document.querySelectorAll('[data-slider="latest-gallery"]');

const latestGalleryOptions = {
  slidesPerView: 1,
  spaceBetween: 10,
  watchOverflow: true,
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  breakpoints: {
    767: {
      slidesPerView: 1,
      spaceBetween: 16,
    },
    1024: {
      slidesPerView: 'auto',
      spaceBetween: 20,
    },
  },
};

latestGallery.forEach((el) => new Swiper(el, latestGalleryOptions));
